export default __webpack_public_path__ + "static/Speedee_W_Rg-4c5c8be2aea3f0ddbd91e6234a8425f4.woff2";